import SectionsMock from './__mock__/Sections';

/* eslint-disable @typescript-eslint/no-empty-interface */
export interface Section {
  name: string;
  displayText: string;
  sections: Section[] | null;
  isVisible: boolean;
}

export interface Sections extends Array<Section> {}

export { SectionsMock };
